import React from "react";
import { SkyLightStateless } from "react-skylight";
import Select from "react-select";
import { RaisedButton, TextField } from "material-ui";
import { Constants } from "../../../../constants";
import { styles } from "../../../menu/styles";
import Header from "../../../header";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import * as validator from "../../../../general/validators/validator";
import request from "../../../../config/axios-config";

export default class FlowModalComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      canEditPapers: false,
      canSetArticolBugetar: false,
      calling: "",
      orderNumber: "",
      error: {
        orderNumber: null,
      },
    };
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
    this.props.onCancel();
  };

  componentDidMount() {
    let users = this.props.users ? this.props.users : [];
    let userEmails = users.map((t, i) => {
      return { value: t.id, label: t.email };
    });
    this.setState({
      calling: this.props.calling,
      userEmails: userEmails,
      selectedUserId: this.props.selectedUserId,
      orderNumber: this.props.orderNumber,
      canEditPapers: this.props.canEditPapers,
      canSetArticolBugetar: this.props.canSetArticolBugetar,
    });
  }

  onOrderNumberChanged = (e) => {
    this.setState({ orderNumber: e.target.value });
  };

  onEmailChange = (val) => {
    this.setState({
      selectedUserId: val,
    });
  };

  onUpdateCanEdit = () => {
    this.setState((oldState) => {
      return {
        canEditPapers: !oldState.canEditPapers,
      };
    });
  };

  onUpdateCanSetArticolBugetar = () => {
    this.setState((oldState) => {
      return {
        canSetArticolBugetar: !oldState.canSetArticolBugetar,
      };
    });
  };

  onSave = () => {
    const dataJson = {
      flowId: this.props.flowId,
      flowStepId: this.props.flowStepId,
      orderNumber: this.state.orderNumber,
      signedById: this.state.selectedUserId,
      canEditPapers: this.state.canEditPapers,
      canSetArticolBugetar: this.state.canSetArticolBugetar,
      calling: this.state.calling,
    };

    if (!this.validateInput()) {
      return;
    }

    request({
      method: "POST",
      url: Constants.SERVER_ENDPOINT + "/flow/add/step",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      data: dataJson,
    })
      .then((json) => {
        this.closeModal();
      })
      .catch((err) => {
        //TODO erorr handling
        this.setState({
          modalIsOpen: true,
        });
      });
  };

  validateInput = () => {
    let isOk = true;
    let error = {};
    if (validator.isEmpty(this.state.orderNumber)) {
      isOk = false;
      error.orderNumber = "Lipseste numarul de ordine";
    }
    if (
      !validator.isEmpty(this.state.orderNumber) &&
      this.state.orderNumber <= 0
    ) {
      isOk = false;
      error.orderNumber = "Numarul de ordine trebuie sa fie pozitiv";
    }
    if (validator.isEmpty(this.state.selectedUserId)) {
      isOk = false;
      error.signedById = "Nu ati selectat persoana care semneaza";
    }
    if (validator.isEmpty(this.state.calling)) {
      isOk = false;
      error.calling = "Lipseste denumirea titlului";
    }

    this.setState({
      error: error,
    });
    return isOk;
  };

  render() {
    return (
      <div>
        <RedirectIfNotLogged />

        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={{
            ...styles.defaultDialogStyles,
            padding: "50px",
            height: "500px",
          }}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          title={<Header title={this.props.title} />}
        >
          <div>
            <table className="table  table-hover">
              <tbody>
                <tr>
                  <td>Numar ordine</td>
                  <td>
                    <TextField
                      type="number"
                      hintText={"Numarul de ordine"}
                      value={this.state.orderNumber}
                      errorText={this.state.error.orderNumber}
                      onChange={this.onOrderNumberChanged}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Email</td>
                  <td>
                    <div>
                      <Select
                        ref="stateSelect"
                        autoFocus
                        options={this.state.userEmails}
                        simpleValue
                        clearable={true}
                        name="selected-state"
                        disabled={false}
                        value={this.state.selectedUserId}
                        onChange={this.onEmailChange}
                        searchable={true}
                      />

                      <div>
                        {this.state.error.signedById && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "rgb(244, 67, 54)",
                              marginTop: "5px",
                            }}
                          >
                            {this.state.error.signedById}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>Titlu</td>
                  <td>
                    <TextField
                      hintText={"Exemplu: AVIZAT"}
                      value={this.state.calling}
                      errorText={this.state.error.calling}
                      onChange={(e) =>
                        this.setState({ calling: e.target.value })
                      }
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate edita continutul?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canEditPapers}
                      onChange={this.onUpdateCanEdit}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Poate edita articolul bugetar?</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={this.state.canSetArticolBugetar}
                      onChange={this.onUpdateCanSetArticolBugetar}
                    />
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td>
                    <RaisedButton
                      primary
                      label={"Save"}
                      onClick={() => this.onSave()}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}
